import React from 'react';
import { string, arrayOf, object } from 'prop-types';
import classnames from 'classnames';

import Icon from 'foundations/Icons/Icon';

import styles from './TypeE.css';

const TypeE = ({ description, sections }) => (
  <div className={classnames(styles.wrapper, 'heroTypeE')}>
    <p className={styles.description}>
      {description}
    </p>
    <div className={styles.sections}>
      {sections.map((section, i) => (
        <div className={styles.section} key={`section-${i}`}>
          <Icon responsive customClasses={styles.sectionIcon} {...section.icon} />

          <p className={styles.sectionDescription}>
            {section.description}
          </p>
        </div>
      ))}
    </div>
  </div>
);

TypeE.propTypes = {
  description: string.isRequired,
  sections: arrayOf(object).isRequired
};

TypeE.displayName = 'TypeE';

export default TypeE;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeE/TypeE.js